module.exports = __webpack_public_path__ + "static/media/e payments.4b33398b.svg";